import { render, staticRenderFns } from "./RejectedReservations.vue?vue&type=template&id=642b7290"
import script from "./RejectedReservations.vue?vue&type=script&lang=js"
export * from "./RejectedReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports